import { create } from "zustand";
import { v4 as uuidv4 } from "uuid";

const session_id = uuidv4();

const useSessionIdStore = create((set) => ({
  session_id: session_id,
}));

export default useSessionIdStore;
